import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  IInterviewQuestionFormInput,
  IInterviewQuestionUpdateProps,
} from "./InterviewQuestion.model";
import { interviewQuestionService } from "../../service/InterviewQuestion/interviewQuestion.service";
import InterviewQuestionForm from "./_interviewQuestionForm";
import { useAuthContext } from "../../context/AuthContext";

const InterviewQuestionUpdate = ({
  data,
  setQuestionDialog,
  loadInterviewQuestions,
}: IInterviewQuestionUpdateProps) => {
  const [id, setId] = useState<number | null>(null);
  const authContext = useAuthContext();
  const currentUser = authContext?.currentUser;

  const methods = useForm<IInterviewQuestionFormInput>({
    mode: "onSubmit",
    defaultValues: {
      user: currentUser?.id || 0,
      question_text: "",
      topic: 0,
      difficulty_level: 1,
      is_active: true,
      choices: [
        { choice_text: "", is_correct: false },
        { choice_text: "", is_correct: false },
        { choice_text: "", is_correct: false },
        { choice_text: "", is_correct: false },
      ],
    },
  });

  useEffect(() => {
    if (data) {
      setId(data.id);
      methods.reset({
        user: data.user,
        question_text: data.question_text,
        topic: data.topic,
        difficulty_level: data.difficulty_level,
        is_active: data.is_active,
        choices: data.choices.map((choice) => ({
          choice_text: choice.choice_text,
          is_correct: choice.is_correct,
        })),
      });
    }
  }, [data]);

  const onSubmit = async (values: IInterviewQuestionFormInput) => {
    if (!id) return;

    values.user = currentUser?.id || data.user;
    const response = await interviewQuestionService.update(id, values);

    if (response.success) {
      loadInterviewQuestions();
      setQuestionDialog(false);
    } else {
      Object.keys(response.errors || {}).forEach((field) => {
        methods.setError(field as any, {
          type: "manual",
          message: response.errors[field],
        });
      });
    }
  };

  return (
    <InterviewQuestionForm
      methods={methods}
      onSubmit={onSubmit}
      isEdit={true}
    />
  );
};

export default InterviewQuestionUpdate;
